import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import * as API from '@/api'
import './plugins/element.js'

import 'swiper/swiper-bundle.min.css'

import 'vant/lib/index.css'



Vue.prototype.$API = API
Vue.config.productionTip = false



new Vue({
  data() {
    return {
        eventHub: new Vue(),
    }
  },
  router,
  render: h => h(App)
}).$mount('#app')
